type Lang = {
  label: string
  value: string
  icon: string
}

export const languages: Lang[] = [
  {
    label: 'English',
    value: 'en',
    icon: 'englishFlag',
  },
  {
    label: 'Indonesian',
    value: 'id',
    icon: 'indonesianFlag',
  },
  {
    label: 'Arabic',
    value: 'ar',
    icon: 'arabicFlag',
  },
  {
    label: 'Thai',
    value: 'th',
    icon: 'thaiFlag',
  },
  {
    label: 'Portuguese',
    value: 'pt',
    icon: 'portugueseFlag',
  },
  {
    label: 'Malay',
    value: 'ms',
    icon: 'malayFlag',
  },
  {
    label: 'Spanish',
    value: 'es',
    icon: 'spanishFlag',
  },
  {
    label: 'Vietnamese',
    value: 'vi',
    icon: 'vietnameseFlag',
  },
  {
    label: 'Japanese',
    value: 'ja',
    icon: 'japaneseFlag',
  },
  {
    label: 'French',
    value: 'fr',
    icon: 'frenchFlag',
  },
  {
    label: 'Uzbek',
    value: 'uz',
    icon: 'uzbekFlag',
  },
  {
    label: 'Kiswahili',
    value: 'sw',
    icon: 'kiswahiliFlag',
  },
]

export const languagesForFilter = [
  {
    text: 'English',
    value: 'en',
  },
  {
    text: 'Indonesian',
    value: 'id',
  },
  {
    text: 'Arabic',
    value: 'ar',
  },
  {
    text: 'Thai',
    value: 'th',
  },
  {
    text: 'Portuguese',
    value: 'pt',
  },
  {
    text: 'Malay',
    value: 'ms',
  },
  {
    text: 'Spanish',
    value: 'es',
  },
  {
    text: 'Vietnamese',
    value: 'vi',
  },
  {
    text: 'Japanese',
    value: 'ja',
  },
  {
    text: 'French',
    value: 'fr',
  },
  {
    text: 'Uzbek',
    value: 'uz',
  },
  {
    text: 'Kiswahili',
    value: 'sw',
  },
]
